module.exports = __webpack_public_path__ + "static/header-image-7f4ee98998fd1347009d32cad38a5876.png";